$(document).ready(function () {
    // Get order ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('id');
    const vidc = urlParams.get('vidc');
    var orderNumber = "";
    var ipaddress = "";

    $('#ovloader').ajaxloader({
        cssClass: 'cssload_zenith',
        content: '<div class="cssload-zenith"></div>',
    });
    if (vidc === 'complete') {
        $('#ovloader').ajaxloader("stop");
        $('.thank-you-order-id').text(orderId);
        $('.thank-you-message').fadeIn(400);
        return;
    }

    if (!orderId) {
        showAlert('No order ID provided. Please include an order ID in the URL.', 'danger');
        return;
    }



    getIPAddress().then(ip => {
        if (ip) {
            console.log('Your IP address:', ip);
            ipaddress = ip;
        } else {
            console.log('Could not retrieve IP address.');
        }
    });
    // Show content and initialize everything else only if we have an order ID
    $('.receipt-content').show();

    // Initialize signature pad with responsive canvas
    const canvas = document.getElementById('signatureCanvas');

    // Set canvas dimensions based on container
    function resizeCanvas() {
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const containerWidth = Math.min(500, canvas.offsetWidth); // Max width of 500px
        canvas.width = containerWidth * ratio;
        canvas.height = (150 * ratio); // Fixed height of 150px
        canvas.getContext("2d").scale(ratio, ratio);
    }

    // Initialize signature pad after setting dimensions
    resizeCanvas();
    const signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)'
    });

    // Resize handler
    window.addEventListener("resize", function () {
        resizeCanvas();
        signaturePad.clear(); // Clear pad after resize
    });

    // Display order ID
    $('#orderId').text(orderId);

    // Set current date
    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
    $('#orderDate').text(currentDate);

    // Fetch order details
    $.ajax({
        url: `https://kodiye.io/Order/getOrderDetails?o=${orderId}`,
        method: 'GET',
        success: function (response) {
            $('#ovloader').ajaxloader("stop");
            displayOrderDetails(response);

            $('#orderNumber').text(response.displayId);
            orderNumber = response.displayId;

            if (response.hasCompletedVerification === true || response.hasCompletedVerification === 'true') {
                // Disable signature pad and buttons
                signaturePad.off();
                $('.signature-buttons button').prop('disabled', true);

                $('.receipt-content').fadeOut(400, function () {
                    // Update order ID in thank you message
                    $('.thank-you-order-id').text(orderNumber);
                    // Show thank you message
                    $('.thank-you-message').fadeIn(400);
                });
            }
        },
        error: function (xhr, status, error) {
            showAlert('Failed to fetch order details', 'danger');

        }
    });

    // Clear signature
    $('#clearSignature').click(function () {
        signaturePad.clear();
    });

    // Submit signature
    $('#submitSignature').click(function () {
        if (signaturePad.isEmpty()) {
            showAlert('Please provide a signature', 'warning');
            return;
        }

        const signatureData = signaturePad.toDataURL();

        // Submit signature to API
        $.ajax({
            url: 'https://kodiye.io/Order/signature',
            method: 'POST',
            data: {
                o: orderId,
                signature: signatureData,
                ipAddress: ipaddress
            },
            success: function (response) {
                if (response && response.success) {
                    // Disable signature pad and buttons
                    signaturePad.off();
                    $('.signature-buttons button').prop('disabled', true);

                    if (response.idVerificationRequired && response.idVerificationUrl) {
                        $('.receipt-content').fadeOut(400, function () {
                            // Update order ID in ID verification message
                            $('.verification-order-id').text(orderNumber);
                            // Set link on verification button
                            $('#startVerificationBtn').attr('href', response.idVerificationUrl);
                            // Show ID verification message
                            $('.id-verification-message').fadeIn(400);
                        });
                    } else {
                        $('.receipt-content').fadeOut(400, function () {
                            // Update order ID in thank you message
                            $('.thank-you-order-id').text(orderNumber);
                            // Show thank you message
                            $('.thank-you-message').fadeIn(400);
                        });
                    }
                } else {
                    const errorMsg = (response && response.message) ? response.message : 'Failed to submit signature';
                    showAlert(errorMsg, 'danger');
                }
            },
            error: function (xhr, status, error) {
                showAlert('Failed to submit signature', 'danger');
            }
        });
    });

    // Function to display order details
    function displayOrderDetails(order) {
        let html = '';

        // Add order items
        if (order.items && order.items.length) {
            order.items.forEach(item => {
                html += `
                            <div class="receipt-row">
                                <span>${item.name}</span>
                                <span>$${item.price.toFixed(2)}</span>
                            </div>
                        `;
            });
        }

        // Add total
        if (order.total) {
            html += `
                        <div class="receipt-row receipt-total">
                            <span>Total</span>
                            <span>$${order.total.toFixed(2)}</span>
                        </div>
                    `;
        }

        $('#orderDetails').html(html);
    }


    async function getIPAddress() {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return null; // Or handle the error appropriately
        }
    }


    // Function to show alerts
    function showAlert(message, type) {
        $('.alert')
            .removeClass('alert-success alert-danger alert-warning')
            .addClass(`alert-${type}`)
            .text(message)
            .fadeIn();

        setTimeout(() => {
            $('.alert').fadeOut();
        }, 3000);
    }
});